const paths = {
    home: '/',
    report: 'report',
    library: 'library',
    support: 'support',
    redirect: 'redirect',
    step: 'step',
    steps: {
        currentSituation: 1,
        yourPeople: 2,
        yourGrowth: 3,
        spaceYouNeed: 4,
        customizeBuildOut: 5,
        scorecard: 6,
    },
    notFound: 'notfound',
    clientConfiguration: 'client-configuration',
    externalAccess: 'externalaccess',
    externalAccessLogin: 'externalaccesslogin',
    externalAccessDenied: 'externalaccessdenied',
    externalAccessBadRequest: 'badrequest',
    loginCallback: '/implicit/callback',
}

export default paths;